import React, { useState } from 'react'
import { MultiStepForm, Step } from 'react-multi-form'
import FormWrapper from './components/forms/FormWrapper'
import { Link } from 'react-router-dom'
import { validateStep1, validateStep2, validateStep3 } from './components/Validations/validation'
import { useDispatch, useSelector } from 'react-redux'
import { 
          moveToNextStep, setErrors, 
       } from '../../../../features/create-project/create-project-slice'
import { 
          setErrors as participantsError, 
          clearErrors as clearParticipantsError,
          setProjectId
        } from '../../../../features/add-participants/add-participants-slice'
import axios from 'axios'
import LoadingSpinner from '../../../../components/LoadingSpinner'
import { clearErrors, setErrors as setupMailErrors, setMailProjectId } from '../../../../features/setup-mail/setup-mail-slice'
import ActivateMail from './components/ActivateMail'


const AddProject = () => {

    const dispatch = useDispatch()
    const { createProjectForm, addParticipants, setupMail } = useSelector( state => state)
    const { step } = createProjectForm
    const [ addProjectLoading , setAddProjectLoading ] = useState(false)    

    const handleNextStep = () => {
        if(step < 5 ){             
           switch(step){
              case 1 :     
                        let step1_validator = validateStep1(createProjectForm.formData)
                         if(step1_validator.validated) {                                  
                                    setAddProjectLoading(true)
                                    axios.post(`${ process.env.REACT_APP_BASE_URL }/project`, createProjectForm.formData)
                                    .then( response => {
                                        if(response.data.success){                                            
                                            dispatch( setProjectId( response.data.data.id ) )
                                            dispatch( setMailProjectId( response.data.data.id ) )
                                            dispatch( moveToNextStep() )
                                            setAddProjectLoading( false )
                                        }
                                    })                             
                           }                               
                         else  {
                                 dispatch( setErrors( step1_validator.errors ) )
                                 window.scrollTo({ top : 0 , behavior : 'smooth' })
                               }                              
              break;
              case 2 :                 
                  let step2_validator = validateStep2( addParticipants.formData )
                  if( step2_validator.validated ){
                       //display a preview modal
                       document.querySelector('#preview-modal').click()
                       dispatch( clearParticipantsError() )
                  }
                  else{
                    dispatch( participantsError( step2_validator.errors ) )
                  }
              break;
              case 3 :
                    let step3_validator = validateStep3( setupMail.formData )
                    if( step3_validator.validated ){
                        dispatch( clearErrors() )
                        dispatch( moveToNextStep() )                        
                    }
                    else{
                        dispatch( setupMailErrors( step3_validator.errors ) )
                        window.scrollTo({ top : 400 , behavior : 'smooth' })
                    }
              break;
           }
       }
    }

    const cancelFormSubmission = () => {         
        window.location.reload()     
        window.scroll(0,0)   
    }

  return (
    <section className='md:mr-2 h-full'>       
         <h1 className='py-1 text-xl text-white bg-green-small font-semibold pl-3 uppercase'>
             Add New Project
         </h1>            
         <div className='mt-8'>
                 <div className='px-2 md:px-12'>
                    <MultiStepForm activeStep={ step } accentColor = '#d43417'>
                        <Step label='Create Project'>                    
                        </Step>
                        <Step label='Add Participants'>                  
                        </Step>
                        <Step label='Setup Email'>                    
                        </Step>
                        <Step label='Finalise'>                    
                        </Step>
                    </MultiStepForm> 
                 </div>
              <div>
                   <FormWrapper />
              </div>
         </div>
          <div className='pb-8 mt-3 ml-8'>
                {    (step < 4) &&
                     <button className='admin-form-btn' onClick={ handleNextStep }>
                         Next <span className='bi bi-arrow-right'>  </span>
                      </button>
                }
                { 
                    (step > 1 && step < 4 ) &&
                         <>
                            <button 
                                   data-bs-toggle='modal'
                                   id='preview-modal'                                   
                                   data-bs-target='#cancelFormSubmission'
                                  className='bg-gray-200 py-2 ml-4 text-sm px-8 mt-8 rounded-full'
                             >
                                Cancel
                             </button>  
                             <div className='modal fixed top-0 left-0 hidden w-full h-full outline-none overflow-x-hidden overflow-y-auto' id='cancelFormSubmission' tabIndex='-1' aria-labelledby='exampleModalLgLabel' aria-modal='true' role='dialog'>
                                <div className='modal-dialog pt-[100px] relative w-[450px] pointer-events-none'>
                                   <div className='modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current'>                                    
                                      <div className='modal-body relative p-4 px-8 text-center'>
                                           <i className='mt-16 bi bi-exclamation-triangle text-center text-[4.5rem] text-red-500'></i>
                                           <h3 className='text-3xl -mt-2 text-center'> Warning </h3>
                                           <p className='text-sm mt-2'>  
                                              Please note that you cannot undo this action. If you proceed with the form cancellation
                                              you will roll back to the earlier step.
                                           </p>
                                           <div className='mt-8 flex justify-end mb-3'>                                                  
                                                <button className='py-2 text-sm px-8  bg-gray-200 rounded-lg' data-bs-dismiss='modal' aria-label='Close'>
                                                    Cancel
                                                </button>
                                                <Link  to={ '/admin/add-new-project'}
                                                        onClick={ cancelFormSubmission }
                                                        className='py-2 text-sm ml-3 px-8 text-white bg-red-500 rounded-lg' 
                                                        data-bs-dismiss='modal' aria-label='Close'
                                                 >
                                                    Yes i understand
                                                </Link>
                                          </div>                                        
                                      </div>
                                   </div>
                                </div>
                            </div>
                         </>                      
                }   
                {
                    (step === 4 ) && <div className='flex justify-end pr-8'>
                        <ActivateMail />
                         <button                                     
                                  className='bg-gray-200 py-2 ml-4 text-sm px-8 mt-8 rounded-full'
                             >
                                Save Draft
                             </button> 
                    </div>
                }
          </div>
          {  addProjectLoading && <LoadingSpinner />  }
    </section>
  )
}

export default AddProject